
import { getLetterUser } from "@/helpers";
import { User } from "@/models";
import { login } from "@/store";
import { Component, Vue } from "vue-property-decorator";
import Tag from "@/components/tags/Tag.vue";
import Cta from "@/components/buttons/Button.vue";
import ClickOutside from "vue-click-outside";

@Component({
  components: { Tag, Cta },
  directives: {
    ClickOutside,
  },
})
export default class Sidebar extends Vue {
  private state = false;
  showFeedbackTip = localStorage.getItem("pcp.feedback_tip_v1") !== "dismissed";

  private switchState(): void {
    this.state = !this.state;
    document.body.style.overflow = this.state ? "hidden" : "";
  }

  private close(): void {
    this.state = false;
    document.body.style.overflow = "";
  }

  beforeDestroy(): void {
    document.body.style.overflow = "";
  }

  get context(): User | null {
    return login.getContext;
  }

  hasAccess(allowed: string[]): boolean {
    const ctx = this.context;
    if (!ctx) return false;
    return allowed.some(
      (r) => ctx.roles.includes(r) || ctx.habilitations.includes(r),
    );
  }

  private letterUser(nom_usage: string): string {
    return getLetterUser(nom_usage);
  }

  dismissFeedbackTip(): void {
    this.showFeedbackTip = false;
    localStorage.setItem("pcp.feedback_tip_v1", "dismissed");
  }

  private goFeedbackTimeline() {
    window.open("https://tally.so/r/jaEBQJ", "_blank");
  }
}
